import _defineProperty from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/inherits.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import parse from 'html-react-parser';
var Banner = /*#__PURE__*/function (_React$Component) {
  function Banner(props) {
    var _this;
    _classCallCheck(this, Banner);
    _this = _callSuper(this, Banner, [props]);
    _this.close = _this.close.bind(_this);
    _this.state = {
      toShow: _this.props.toShow
    };
    return _this;
  }
  _inherits(Banner, _React$Component);
  return _createClass(Banner, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.toShow !== this.props.toShow) {
        this.setState({
          toShow: this.props.toShow
        });
      }
    }
  }, {
    key: "close",
    value: function close() {
      this.setState({
        toShow: false
      });
      if (this.props.toClose) {
        this.props.toClose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var cl = this.props.className || '';
      var _this$props = this.props,
        btnLink = _this$props.btnLink,
        btnCopy = _this$props.btnCopy,
        subCopy = _this$props.subCopy,
        secondaryBtn = _this$props.secondaryBtn,
        heading = _this$props.heading;
      var returnCTA = function returnCTA() {
        var setClassName = function setClassName() {
          if (subCopy || secondaryBtn) {
            return "w-100 w-md-auto flex-md-shrink-0 ".concat(_this2.props.secondaryBtn ? 'ms-3' : '');
          }
          return "".concat(secondaryBtn ? 'me-3 flex-grow-1 flex-md-grow-0' : 'w-md-auto w-100', " ").concat(subCopy && !secondaryBtn ? 'mb-2 btn-min-width' : '', "  ");
        };
        if (btnLink) {
          return React.createElement("a", _objectSpread(_objectSpread({
            className: "btn btn-primary text-nowrap ".concat(setClassName()),
            href: btnLink
          }, _this2.props.dataOp !== '' ? {
            'data-op': _this2.props.dataOp || 'SLD'
          } : {}), _this2.props.btnAttributes || {}), parse(btnCopy));
        }
        return React.createElement("button", _objectSpread(_objectSpread({
          type: "button",
          onClick: _this2.props.mainCTAclick,
          className: "btn btn-primary ".concat(setClassName())
        }, _this2.props.dataOp !== '' ? {
          'data-op': _this2.props.dataOp || 'SLD'
        } : {}), _this2.props.btnAttributes || {}), parse(btnCopy));
      };
      return React.createElement("div", {
        className: "".concat(cl, " position-fixed sticky-banner ").concat(this.props.variant === 'light' ? 'bg-white border' : 'bg-midnight-blue text-white', " p-3 pb-md-3 d-md-flex ").concat(this.state.toShow ? 'toShow' : '')
      }, React.createElement("div", {
        className: "d-md-flex justify-content-md-between flex-md-grow-1 align-items-center"
      }, React.createElement("p", {
        className: "mb-md-0 fw-bold body-text-sm text-center text-md-start flex-grow-md-0 ".concat(this.props.toHideCloseIcon ? 'pe-md-5' : 'pe-5')
      }, parse(heading)), subCopy || secondaryBtn ? React.createElement("div", {
        className: "".concat(secondaryBtn ? 'd-flex' : '', " ").concat(subCopy ? 'flex-md-grow-0 flex-wrap text-center' : ' flex-md-shrink-0')
      }, secondaryBtn || null, returnCTA(), subCopy ? React.createElement("p", {
        className: "mb-0 lh-1 mt-2 ".concat(secondaryBtn ? 'w-100' : '', " ").concat(this.props.variant === 'light' ? 'text-gray' : 'text-white text-opacity-70')
      }, React.createElement("small", null, parse(subCopy))) : null) : returnCTA()), (this.props.toHideCloseIcon === undefined || !this.props.toHideCloseIcon) && React.createElement("button", {
        type: "button",
        className: "close btn-reset ps-md-3",
        "aria-label": "Close",
        "data-link-both": "sld-close",
        onClick: this.close
      }, React.createElement("span", {
        "aria-hidden": "true",
        className: "ecs-font-icon-act-close"
      })));
    }
  }]);
}(React.Component);
export { Banner as default };